/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/* BD · Klaviyo-Ereignis „Added to Cart" ---------------------------------------
   WARUM ES DAS GIBT: Shopifys Web-Pixel liefert diese Metrik NICHT — am
   30.08. und erneut am 31.08.2026 an der vollständigen Metrikliste gemessen
   (42 Metriken, keine davon „Added to Cart"), trotz echter Test-Warenkorb-
   ereignisse. Ohne dieses Ereignis hat der Flow „Warenkorb vor Checkout"
   keinen Auslöser. Der bestehende Warenkorb-Flow hängt dagegen an „Checkout
   Started" und läuft serverseitig über Shopifys Webhook — dieser hier ist
   bewusst der Schritt DAVOR.

   🛑 ZWEI BEDINGUNGEN, DIE NICHT WEGFALLEN DÜRFEN:

   1. Es feuert NUR mit erteilter Marketing-Einwilligung (Shopify Consent API).
      Ohne diese Sperre ginge Besucherverhalten vor der Banner-Zustimmung an
      Klaviyo — das App-Embed lädt zwar ungegatet (bewusste Tobias-Entscheidung
      vom 26.08., sonst erscheint kein Pop-up), aber es TRACKT ohne Zustimmung
      nachweislich nicht. Diese Datei darf diesen Zustand nicht aufweichen.

   2. Klaviyo ordnet das Ereignis nur einem IDENTIFIZIERTEN Browser zu.
      Identifiziert wird ein Browser erst durch eine Klaviyo-Formular-Einsendung
      oder den Klick auf einen Link in einer Klaviyo-Mail (s.
      design-specs/anti-fehlalarm.md). Der darauf gebaute Flow erreicht deshalb
      nur diese Population — nicht jeden Besucher. Das ist Bauart, kein Fehler:
      Wer den Flow später „zu klein" findet, ändert daran nichts durch mehr
      Tracking, sondern nur durch mehr identifizierte Browser.

   ⚠️ Diese Datei wird auch von layout/password.liquid geladen, wo es keinen
   Warenkorb gibt — der Code ist deshalb durchgehend defensiv und wirft nie.
------------------------------------------------------------------------------*/
(function () {
  'use strict';

  // Marketing-Einwilligung nach Shopify Consent API. Im Zweifel FALSE:
  // fehlt die API (Dev-Proxy kennt sie nicht), wird nicht getrackt.
  function darfTracken() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return false;
      if (typeof cp.marketingAllowed === 'function') return cp.marketingAllowed() === true;
      if (typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed() === true;
      return false;
    } catch (e) {
      return false;
    }
  }

  function geld(cent) {
    return typeof cent === 'number' ? Math.round(cent) / 100 : null;
  }

  function absolut(pfad) {
    if (!pfad) return null;
    if (pfad.indexOf('//') === 0) return window.location.protocol + pfad;
    if (pfad.indexOf('http') === 0) return pfad;
    return window.location.origin + pfad;
  }

  document.addEventListener('on:cart:loaded', function (evt) {
    try {
      var d = evt && evt.detail;
      // Nur echtes Hinzufügen — nicht CHANGE, UPDATE oder CLEAR.
      if (!d || d.type !== 'ADD') return;
      if (!d.cart || !Array.isArray(d.items) || !d.items.length) return;
      if (!darfTracken()) return;

      // Klaviyos Queue: vor dem Laden von klaviyo.js ein Array, danach das Objekt.
      var kl = window.klaviyo;
      if (!kl || typeof kl.push !== 'function') return;

      var cart = d.cart;
      var zeilen = Array.isArray(cart.items) ? cart.items : [];
      var neueIds = d.items.map(function (i) { return Number(i.id); });
      var neu = zeilen.filter(function (z) { return neueIds.indexOf(Number(z.variant_id)) !== -1; });
      var erst = neu[0] || zeilen[0];
      if (!erst) return;

      kl.push(['track', 'Added to Cart', {
        $value: geld(cart.total_price),
        AddedItemProductName: erst.product_title || erst.title || null,
        AddedItemProductID: erst.product_id != null ? String(erst.product_id) : null,
        AddedItemVariantID: erst.variant_id != null ? String(erst.variant_id) : null,
        AddedItemSKU: erst.sku || null,
        AddedItemImageURL: absolut(erst.image),
        AddedItemURL: absolut(erst.url),
        AddedItemPrice: geld(erst.final_price),
        AddedItemQuantity: erst.quantity || 1,
        ItemNames: zeilen.map(function (z) { return z.product_title || z.title; }),
        CheckoutURL: window.location.origin + '/checkout',
        Items: zeilen.map(function (z) {
          return {
            ProductID: z.product_id != null ? String(z.product_id) : null,
            SKU: z.sku || null,
            ProductName: z.product_title || z.title || null,
            Quantity: z.quantity || 1,
            ItemPrice: geld(z.final_price),
            RowTotal: geld(z.final_line_price),
            ProductURL: absolut(z.url),
            ImageURL: absolut(z.image)
          };
        })
      }]);
    } catch (e) {
      /* Tracking darf den Kaufweg unter keinen Umständen stören. */
    }
  });
})();
